import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { Back, Footer, SubmitButton } from '..';

import { QuizContext } from '../../../store/quiz';
import { media } from '../../../utils/styles';
import { Checkbox } from '../Checkbox';
import { FormGroup } from '../FormGroup';

export const Email = () => {
  const {
    store: { submitAnswers, prevStep, answers, quizLog },
  } = useContext(QuizContext);

  const [email, setEmail] = useState(answers['email'] || '');
  const [name, setName] = useState(answers['name'] || '');
  const [newsletter, setNewsletter] = useState(answers['newsletter'] || true);

  const onSubmit = e => {
    e.preventDefault();
    submitAnswers([
      {
        name: 'email',
        value: email,
      },
      {
        name: 'name',
        value: name,
      },
      {
        name: 'newsletter',
        value: newsletter,
      },
    ]);
    quizLog(`Answer_${email}`, 'email');
    quizLog(`Answer_${name}`, 'name');
    quizLog(`Answer_${newsletter}`, 'newsletter');
  };

  return (
    <Wrap onSubmit={onSubmit}>
      <Heading>We need your details to complete the offer</Heading>
      <Form>
        <FormGroup
          value={email}
          onChange={e => setEmail(e.target.value)}
          onClear={() => setEmail('')}
          placeholder="Your Email"
          type="email"
          name="email"
          required
        />
        <FormGroup
          value={name}
          onChange={e => setName(e.target.value)}
          onClear={() => setName('')}
          placeholder="Your Name"
          type="text"
          name="name"
          required
        />
        <StyledCheckbox
          id="newsletter_checkbox"
          value={newsletter}
          onChange={() => setNewsletter(prev => !prev)}
          checked={newsletter}
        >
          By checking this box you agree to get future information from us.
        </StyledCheckbox>
        <Checkbox id="privacy_checkbox" required value="1" name="privacy">
          I agree to the ReshapeMe{' '}
          <a href="https://reshape.me/privacy-policy" target="_blank" rel="noreferrer">
            Privacy Policy
          </a>
          .
        </Checkbox>
        <Disclaimer>
          We don't send spam or share email addresses. We respect your privacy.
        </Disclaimer>
      </Form>
      <Footer>
        <div>
          <SubmitButton type="submit" disabled={!name || !email}>
            Continue
          </SubmitButton>
        </div>
        <Back onBack={prevStep} />
      </Footer>
    </Wrap>
  );
};

const StyledCheckbox = styled(Checkbox)`
  margin-top: 18px;
  ${media.phone} {
    margin-top: 26px;
  }
`;

const Disclaimer = styled.p`
  padding: 16px;
  background: #f8fafb;
  border-radius: 4px;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  color: #3b3b3b;
  margin: 34px 0 40px;
`;

const Form = styled.div`
  width: 320px;
  max-width: 100%;
  margin: 0 auto;
`;

const Heading = styled.h1`
  width: 572px;
  max-width: 100%;
  font-weight: bold;
  font-size: 32px;
  margin: 0 auto 48px;
  line-height: 43px;
  text-transform: capitalize;
  ${media.phone} {
    margin: 0 0 24px;
    font-size: 28px;
    line-height: 36px;
  }
`;

const Wrap = styled.form`
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
`;
